import Vue from 'vue'
import LazyYoutubeVideo from 'vue-lazy-youtube-video'
import 'vue-lazy-youtube-video/dist/style.css'

Vue.component('LazyYoutubeVideo', LazyYoutubeVideo)
